var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { selectCoopLanguageSettings, selectRankingFilterLanguageSettings, } from "../../../balancingSelectors/selectBalancingLanguage";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsModalOpen, selectModalTabId } from "../../../selectors/selectModalTabId";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { IdModal } from "../../modals/IdModal";
import { ButtonListGreen } from "../common/ButtonListGreen";
import { ButtonListNormal } from "../common/ButtonListNormal";
import { ButtonPrimary } from "../common/ButtonPrimary";
import { Icon } from "../icon/Icon";
import { List } from "../list/List";
import { TextLoca } from "../text/TextLoca";
var DialogLanguageFilterDOM = /** @class */ (function (_super) {
    __extends(DialogLanguageFilterDOM, _super);
    function DialogLanguageFilterDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedLang: _this.props.selectedFilterLanguage,
            tabId: _this.props.tabId,
        };
        _this.getLanguageSettingLayout = function (langSetting) {
            var assetName = langSetting.assetName, locakey = langSetting.locakey;
            var selectedLang = _this.state.selectedLang;
            var isSelected = selectedLang.locakey === locakey;
            var ButtonComponent = isSelected ? ButtonListGreen : ButtonListNormal;
            return (React.createElement("div", { className: "v-padding__medium", key: "btn-" + langSetting.locakey },
                React.createElement(ButtonComponent, { onClick: function () { return _this.setFilter(langSetting); } },
                    React.createElement("div", { className: "flex flex--aligned w100 h-padding__small" },
                        React.createElement(Icon, { icon: assetName, styleId: IdStyles.IconMedium }),
                        React.createElement("div", { className: "h-padding__small" }),
                        React.createElement(TextLoca, { id: locakey, className: IdStyles.TextButtonDefault })))));
        };
        _this.onConfirm = function () {
            var _a = _this.props, onConfirm = _a.onConfirm, onRankingRequest = _a.onRankingRequest, tabId = _a.tabId, name = _a.name;
            var selectedLang = _this.state.selectedLang;
            onConfirm(selectedLang, tabId);
            if (onRankingRequest) {
                var nameSearch = selectedLang && selectedLang.languageCode === utilLoca.getCurrentLanguage()
                    ? name
                    : undefined;
                onRankingRequest(nameSearch, undefined);
            }
        };
        _this.setFilter = function (selectedLang) {
            _this.setState({
                selectedLang: selectedLang,
            });
        };
        return _this;
    }
    DialogLanguageFilterDOM.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, languageSettings = _a.languageSettings;
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.selectLanguage, onClose: onClose, className: IdStyles.ModalBackgroundLanguageSelection },
            React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around h100" },
                React.createElement("div", { className: "" + IdStyles.LanguageSelectionBackground },
                    React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
                        React.createElement(List, { items: languageSettings, renderItem: this.getLanguageSettingLayout, className: "flex flex--wrap flex--around" }))),
                React.createElement(ButtonPrimary, { onClick: this.onConfirm },
                    React.createElement(TextLoca, { id: IdLoca.confirm, className: IdStyles.TextButtonDefault })))));
    };
    return DialogLanguageFilterDOM;
}(React.Component));
var mapState = function (state, ownProps) { return (__assign({}, ownProps, { languageSettings: selectIsModalOpen(state, IdModal.Coop)
        ? selectCoopLanguageSettings()
        : selectRankingFilterLanguageSettings(), tabId: selectModalTabId(state, IdModal.Coop) })); };
export var DialogLanguageFilter = connect(mapState)(DialogLanguageFilterDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/menu-language-filter/DialogLanguageFilter.tsx
// module id = 911
// module chunks = 3